import { useUserStore } from '@/stores/user'
import type { RouteLocationNormalized } from 'vue-router'
import { checkAndRedirectIfAnotherUserLoggedIn } from '@/utils/userSessionGuard'

export async function authGuard(to: RouteLocationNormalized, from: RouteLocationNormalized) {
  const userStore = useUserStore()

  // Login / ErrorPage は常に通す
  if (to.name === 'Login' || to.name === 'ErrorPage') return null

  if (from.name !== 'Login') {
    // Login 以外からの場合、他ユーザでログインされていないかチェック
    const anotherUserLoggedIn = await checkAndRedirectIfAnotherUserLoggedIn()
    if (!anotherUserLoggedIn) {
      // セッション延長
      await userStore.fetchUserInfo()
    }
  }
}
